import React from "react"
import { Col, Card } from "antd"
import { useMediaQuery } from "react-responsive"

const HowItWorksItem = ({ dataItem }) => {
  const isMobileScreen = useMediaQuery({ query: "(max-width: 992px)" })

  return (
    <>
      <Col span={24} lg={{ span: 6 }}>
        <Card style={{
          border: "none",
          boxShadow: "0px 8px 40px rgba(45, 85, 120, 0.12)",
          textAlign: "center",
          paddingRight: 0,
          paddingTop: "30px",
          paddingBottom: "30px",
          paddingLeft: 0,
          borderRadius: "6px",
          marginBottom: isMobileScreen ? "15px" : ""
        }}>
          <img src={dataItem.image} height="45px" style={{
            marginRight: "10px"
          }} />
          <div
            className="data-item-description"
            style={{
              fontFamily: "Trenda-regular",
              fontSize: "16px",
              color: "#2D3948",
              marginTop: "15px",
              letterSpacing: "1px"
            }}
          >
            {dataItem.description}
          </div>
        </Card>
      </Col>
    </>
  )
}

export default HowItWorksItem
